import { Check, Icon } from "lucide-react";
import { PricingGroup } from "../../../config/marketing/pricing";
import React from "react";

export default function FeatureColumn({ group }: { group: PricingGroup }) {
    const Icon = group.icon;
    return (
        <div className="space-y-4">
            <div className="flex flex-col items-start gap-2">
                <div className="flex gap-2">
                    <div className="flex items-center justify-center rounded-full bg-primary/10 p-2">
                        <Icon className="h-4 w-4 text-primary" />
                    </div>
                    <h4 className="font-semibold tracking-tight text-xl md:text-2xl text-text-primary">{group.title}</h4>
                </div>
                <div>
                    <p className="mt-1 md:text-lg italic tracking-tight text-text-secondary">{group.subtitle}</p>
                </div>
            </div>

            <ul className="space-y-4">
                {group.features.map((feature) => (
                    <li key={feature.title} className="flex gap-3">
                        <Check className="mt-1 h-4 w-4 flex-shrink-0 text-primary" />

                        <div>
                            <p className="text-lg md:text-xl tracking-tight font-semibold text-black">{feature.title}</p>

                            {feature.description && (
                                <p className="mt-1 md:text-lg text-text-secondary font-medium tracking-tight leading-relaxed">
                                    {feature.description}
                                </p>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
